import { Component } from '@angular/core';

@Component({
	selector: 'mb-family-changes-to-holdings-skeleton',
	templateUrl: './family-changes-to-holdings-skeleton.component.html',
	styleUrls: ['./family-changes-to-holdings-skeleton.component.scss']
})
export class FamilyChangesToHoldingsSkeletonComponent {
	public GHOST_COLUMNS = Array(10).fill(0);
	public GHOST_ROWS = Array(4).fill(0);

}
